export const surveyQueryKeys = {
  all: ['surveys'] as const,
  surveys: () => [...surveyQueryKeys.all, 'survey'] as const,
  survey: (id: string) => [...surveyQueryKeys.surveys(), id] as const,
  surveysBySubject: (subjectId: string) =>
    [...surveyQueryKeys.all, 'by-subject', subjectId] as const,
  surveysByTenant: (tenantId: string) => [...surveyQueryKeys.all, 'by-tenant', tenantId] as const,
};
